import React from 'react';
import FinancialInstitutionForm from '../components/company/FinancialInstitutionForm';
import { PageContainer } from '../components/layout/PageContainer';
import { useAccountType } from '../hooks/useAccountType';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { AccountStatusNotice } from '../components/auth/AccountStatusGate';

interface FinancialInstitutionProps {
  financialInstitutionId?: string;
}

const FinancialInstitution: React.FC<FinancialInstitutionProps> = ({ financialInstitutionId }) => {
  const { accountType, isLoading, isCompany, isNewAccount } = useAccountType();
  const navigate = useNavigate();
  
  // Afficher un skeleton inline pendant le chargement (pas de loader bloquant)
  if (isLoading) {
    return (
      <PageContainer>
        <div className="max-w-4xl mx-auto p-6 space-y-6">
          <div className="h-8 bg-gray-200 rounded w-64 animate-pulse"></div>
          <div className="h-4 bg-gray-200 rounded w-96 animate-pulse"></div>
          <div className="space-y-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="h-12 bg-gray-200 rounded animate-pulse"></div>
            ))}
          </div>
        </div>
      </PageContainer>
    );
  }
  
  // Si l'utilisateur est une entreprise, rediriger vers le bon formulaire
  if (isCompany) {
    return (
      <PageContainer>
        <div className="max-w-2xl mx-auto p-6">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 text-center">
            <AlertTriangle className="w-12 h-12 text-yellow-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Accès non autorisé
            </h2>
            <p className="text-gray-600 mb-4">
              Votre compte est enregistré comme <strong>PME/Entreprise</strong>.
              Cette section est réservée aux Institutions Financières.
            </p>
            <button
              onClick={() => navigate('/company')}
              className="px-6 py-2 bg-[#197ca8] text-white rounded-md hover:bg-[#156a92] transition-colors"
            >
              Aller à mon profil Entreprise
            </button>
          </div>
        </div>
      </PageContainer>
    );
  }
  
  // Afficher le formulaire pour les institutions ou les nouveaux comptes
  return (
    <PageContainer>
      <AccountStatusNotice />
      <FinancialInstitutionForm financialInstitutionId={financialInstitutionId} />
    </PageContainer>
  );
};

export default FinancialInstitution;
